export default "__VITE_ASSET__DO_4h1nq__"